import React from 'react'
import PropTypes from 'prop-types';

import BaseComponent from 'common/BaseComponent'
import Input from 'common/Input'
import theme from 'dialogs/Complaint.scss'
import {getMessage as msg} from 'MessageBundle'
import Select from 'common/Select'
import ImeiList from 'dialogs/NewComplaint/Form/ImeiList'

export default class Information extends BaseComponent {

    constructor(props) {
        super(props);
        this.view = {
            "": () => {},
            "invoice": this.showInvoiceInput,
            "creditNote": this.showCreditNoteInput,
            "deliveryNote": this.showDeliveryInput,
            "imei": this.showImeiInput,
            "none": this.showNone
        };

        this.informationType = new Map([
            ["invoice", msg("newComplaint.information.types.invoice")],
            ["creditNote", msg("newComplaint.information.types.creditNote")],
            ["deliveryNote", msg("newComplaint.information.types.deliveryNote")],
            ["imei", msg("newComplaint.information.types.imei")],
            ["none", msg("newComplaint.information.types.none")]
        ])
    }

    showInvoiceInput = () => {
        return (
            <div>
                <div>{msg('newComplaint.information.invoiceHint')}</div>
                <div className={theme.row}>
                    <Input id="invoice" value={this.props.invoice} name="invoice" errorMessages={this.props.errorMessages}
                        onChange={this.props.onChange("invoice")} required label={msg("newComplaint.information.types.invoice") + ":"} />
                </div>
            </div>
        )
    };

    showCreditNoteInput = () => {
        return (
            <div>
                <div>{msg('newComplaint.information.creditNoteHint')}</div>
                <div className={theme.row}>
                    <Input id="creditNote" value={this.props.creditNote} name="creditNote" errorMessages={this.props.errorMessages}
                        onChange={this.props.onChange("creditNote")} required label={msg("newComplaint.information.types.creditNote") + ":"}/>
                </div>
            </div>
        );
    };

    showDeliveryInput = () => {
        return (
            <div>
                <div>{msg('newComplaint.information.deliveryNoteHint')}</div>
                <div className={theme.row}>
                    <Input id="deliveryNote" value={this.props.deliveryNote} name="deliveryNote" errorMessages={this.props.errorMessages}
                        onChange={this.props.onChange("deliveryNote")} required label={msg("newComplaint.information.types.deliveryNote") + ":"}/>
                </div>
            </div>
        );
    };

    showImeiInput = () => {
        return (
            <div>
                <div>{msg('newComplaint.information.imeiHint')}</div>
                <ImeiList id="imeiList" value={this.props.imei} newImei={this.props.newImei} errorMessages={this.props.errorMessages}
                    onChange={this.props.onChange} max={10} onImeiAddition={this.props.onImeiAddition} onImeiRemoval={this.props.onImeiRemoval}/>
            </div>
        );
    };

    showNone = () => {
        return (
            <div>
                <div>{msg('newComplaint.information.noneHint')}</div>
            </div>
        );
    };

    handleTypeChange = (view) => {
        this.props.onTypeChange(view.target.value);
    };

    render() {
        return (<div className={theme.complaint}>
                    <h3>{msg('newComplaint.information.title')}</h3>
                    <p>{msg('newComplaint.information.instruction')}</p>
                    <div className={theme.row}>
                        <Select id="infoType" value={this.props.infoType} onChange={this.handleTypeChange}
                            label={msg("newComplaint.information.type")} options={this.informationType}/>
                    </div>
                    {this.view[this.props.infoType]()}
                </div>)
    }
}

Information.propTypes = {
    invoice: PropTypes.string,
    creditNote: PropTypes.string,
    deliveryNote: PropTypes.string,
    imei: PropTypes.array,
    onChange: PropTypes.func,
    onTypeChange: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/dialogs/NewComplaint/Form/Information/index.js